import { useEffect, useState, useRef } from 'react';
import { USER_POOL_CLIENT_ID, USER_POOL_DOMAIN } from 'utils/configs';
import { exchangeCodeForTokens, saveCognitoTokens } from 'utils/authTokens';

const AuthCallback = () => {
  const [status, setStatus] = useState('processing');
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;

    const handleCallback = async () => {
      hasProcessed.current = true;

      console.log('🔄 Standalone AuthCallback');

      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const error = urlParams.get('error');
      const stateParam = urlParams.get('state');

      console.log('State:', stateParam);

      //** STANDALONE MODE */
      if (error) {
        console.error('❌ OAuth error:', error);
        setStatus('error');
        setTimeout(
          () => window.location.replace('/signin?error=' + error),
          2000
        );
        return;
      }

      if (!code || !stateParam) {
        console.error('❌ Missing code or state');
        setStatus('error');
        setTimeout(() => window.location.replace('/signin'), 2000);
        return;
      }

      try {
        //** Use from state */
        const stateData = JSON.parse(atob(stateParam));
        const { verifier, redirectUri } = stateData;

        console.log('🔄 Exchanging code for tokens manually...');
        console.log('📍 Using redirect_uri:', redirectUri);

        //** Exchange the code for tokens */
        const tokens = await exchangeCodeForTokens(
          code,
          redirectUri,
          verifier,
          USER_POOL_DOMAIN,
          USER_POOL_CLIENT_ID
        );

        //** Save tokens */
        saveCognitoTokens(tokens);

        setStatus('success');

        setTimeout(() => {
          window.location.replace('/');
        }, 200);
      } catch (err) {
        console.error('❌ Error during token exchange:', err);
        setStatus('error');

        setTimeout(
          () => window.location.replace('/signin?error=token_exchange_failed'),
          1000
        );
      }
    };

    handleCallback();
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      {status === 'processing' && (
        <>
          <div style={{ fontSize: '50px' }}>⏳</div>
          <p style={{ marginTop: '20px', color: '#666', fontSize: '16px' }}>
            Processing authorization...
          </p>
        </>
      )}

      {status === 'success' && (
        <>
          <div style={{ fontSize: '50px', color: '#4CAF50' }}>✓</div>
          <p style={{ marginTop: '20px', color: '#666', fontSize: '16px' }}>
            Authorization successful!
          </p>
          <p style={{ marginTop: '8px', color: '#999', fontSize: '12px' }}>
            Redirecting to the main page...
          </p>
        </>
      )}

      {(status === 'success-close' || status === 'error-close') && (
        <>
          <div
            style={{
              fontSize: '50px',
              color: status === 'success-close' ? '#4CAF50' : '#f44336',
            }}
          >
            {status === 'success-close' ? '✓' : '✗'}
          </div>
          <p style={{ marginTop: '20px', color: '#666', fontSize: '16px' }}>
            You can close this window
          </p>
        </>
      )}

      {status === 'error' && (
        <>
          <div style={{ fontSize: '50px', color: '#f44336' }}>✗</div>
          <p style={{ marginTop: '20px', color: '#666', fontSize: '16px' }}>
            Authorization error
          </p>
          <p style={{ marginTop: '8px', color: '#999', fontSize: '12px' }}>
            Return to login page...
          </p>
        </>
      )}
    </div>
  );
};

export default AuthCallback;
